// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guarantee-options[data-v-86f45e2a] {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 18px;\n}\n.guarantee-options .el-checkbox[data-v-86f45e2a] {\n  margin-right: 0;\n}", ""]);
// Exports
module.exports = exports;
